/* eslint-disable sort-keys */
export const urls: Record<
  'pt',
  Record<string, '/l/pt/pt' | `/l/pt/pt/${string}`>
> = {
  pt: {
    // Home
    '': '/l/pt/pt/home',

    // Alumni
    alumni: '/l/pt/pt/alumni',

    // B2B
    empresa: '/l/pt/pt/b2b',
    'empresa/contacto': '/l/pt/pt/b2b/apply',

    // Blog
    blog: '/l/pt/pt/blog',

    // Campus
    lisboa: '/l/pt/pt/campus/lis',
    remoto: '/l/pt/pt/campus/rmt',

    // Career
    'servicos-de-carreira': '/l/pt/pt/career',

    // Courses
    'programacao-web': '/l/pt/pt/course/wd',
    'data-analytics': '/l/pt/pt/course/da',
    'ux-ui-design': '/l/pt/pt/course/ux',
    ciberseguranca: '/l/pt/pt/course/cy',

    // FAQ
    faq: '/l/pt/pt/faq',

    // Financing Options
    financiamento: '/l/pt/pt/financing',

    // Forms
    inscrever: '/l/pt/pt/apply',
    inscrever2: '/l/pt/pt/full-apply',
    contacto: '/l/pt/pt/contact',
    'formulario-de-financiamento': '/l/pt/pt/financing-form',
    obrigado: '/l/pt/pt/thank-you',
    obrigado2: '/l/pt/pt/thank-you-dynamic',

    // Syllabus Forms
    'ciberseguranca/plano-de-estudos': '/l/pt/pt/syllabus/cy',
    'data-analytics/plano-de-estudos': '/l/pt/pt/syllabus/da',
    'ux-ui-design/plano-de-estudos': '/l/pt/pt/syllabus/ux',
    'programacao-web/plano-de-estudos': '/l/pt/pt/syllabus/wd',
    'data-science-machine-learning/plano-de-estudos': '/l/pt/pt/syllabus/ml',
    'inteligencia-artificial/plano-de-estudos': '/l/pt/pt/syllabus/ai',
    'devops-cloud-computing/plano-de-estudos': '/l/pt/pt/syllabus/dv',
    'marketing-digital/plano-de-estudos': '/l/pt/pt/syllabus/mk',

    // Legal Pages
    'politica-de-privacidade': '/l/pt/pt/privacy',
    'termos-de-uso': '/l/pt/pt/terms',

    // PDP
    'programacao-web/lisboa': '/l/pt/pt/pdp/wd/lis',
    'programacao-web/remoto': '/l/pt/pt/pdp/wd/rmt',
    'data-analytics/lisboa': '/l/pt/pt/pdp/da/lis',
    'data-analytics/remoto': '/l/pt/pt/pdp/da/rmt',
    'ux-ui-design/lisboa': '/l/pt/pt/pdp/ux/lis',
    'ux-ui-design/remoto': '/l/pt/pt/pdp/ux/rmt',
    'ciberseguranca/lisboa': '/l/pt/pt/pdp/cy/lis',
    'ciberseguranca/remoto': '/l/pt/pt/pdp/cy/rmt',
    'data-science-machine-learning/remoto': '/l/pt/pt/pdp/ml/rmt',
    'inteligencia-artificial/remoto': '/l/pt/pt/pdp/ai/rmt',
    'devops-cloud-computing/remoto': '/l/pt/pt/pdp/dv/rmt',
    'marketing-digital/remoto': '/l/pt/pt/pdp/mk/rmt',
  },
};
/* eslint-enable sort-keys */
